// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ActionBar from '../../layout/ActionBar';
import {
  saveTerritory,
  getTerritoryById,
} from '../../../actions/territoryActions';
import Loading from '../../common/Loading';
import DisallowedSkuList from './components/DisallowedSkuList';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../../util/pageTitle';
import { useNavigate, useParams } from 'react-router-dom';

function DisallowedSkus({ saveTerritory }) {
  const { id } = useParams();
  const [pageTitle, setPageTitle] = usePageTitle([
    'Disallowed SKUs',
    'Territories',
    'Settings',
  ]);
  const { t } = useTranslation();
  const [reload] = useState();
  const navigate = useNavigate();
  const [territory, setTerritory] = useState({});

  useEffect(() => {
    if (id) {
      getTerritoryById(id)
        .then((d) => {
          setTerritory(d);
          setPageTitle([d.name, 'Disallowed SKUs', 'Territories', 'Settings']);
        })
        .catch((e) => {
          console.error(e);
          navigate('/settings/territories/');
          toast.error(t('Territory not found'));
        });
    }
  }, [id, setPageTitle, navigate, t]);

  return territory ? (
    <>
      <ActionBar></ActionBar>

      <DisallowedSkuList reload={reload} territoryId={id} />
    </>
  ) : (
    <Loading></Loading>
  );
}

const mapDispatchToProps = {
  saveTerritory,
};

export default connect(null, mapDispatchToProps)(DisallowedSkus);
